import React from 'react';
import Unit from '@leverege/unit';
import { Flex, NumericInput } from '@leverege/ui-elements';
// import { Formatters } from '@leverege/ui-attributes'
import UnitSelector from "./UnitSelector.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class UnitEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      changeKey: Date.now()
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate(prevProps) {
    const {
      value: pValue,
      valueType: pValueType
    } = prevProps;
    const {
      value,
      valueType
    } = this.props;
    if (value?.type !== pValue?.type || valueType !== pValueType) {
      this.init();
    }
  }
  init() {
    const {
      value,
      valueType: type,
      units: pUnits
    } = this.props;
    const units = pUnits?.map(unit => {
      const u = Unit.getUnit(unit);
      return u;
    }) || Unit.getUnitsOfType(type);

    // if ( type === 'temperature' ) {
    //   units = [ ...units, 'C', 'F' ]
    // }

    let baseUnit = value?.unit;

    // if ( formatter ) {
    //   baseUnit = formatter.unit || value.unit 
    // } else {
    //   baseUnit = value.unit 
    // }

    if (!baseUnit) {
      baseUnit = units?.[0];
    }
    this.setState({
      units,
      baseUnit
    });
    this.unitRegex = new RegExp(`^(-?[0-9]*\\.?[0-9]+)[ ]*(${units.join('|')})?$`);
  }
  onChange = evt => {
    const {
      valueType,
      onChange: pOnChange,
      eventData,
      value: currValue
    } = this.props;
    const {
      baseUnit
    } = this.state;
    this.setState({
      changeKey: Date.now()
    }, () => {
      let val;
      if (evt.data === 'setValue') {
        val = {
          type: valueType,
          value: evt.value,
          unit: currValue?.unit || baseUnit
        };
      } else {
        val = {
          type: valueType,
          value: currValue?.value,
          unit: evt.value
        };
      }
      pOnChange({
        data: eventData,
        value: val
      });
    });
  };
  validator = val => {
    return !val || val.match(this.unitRegex) != null;
  };
  render() {
    const {
      usage,
      context,
      valueType,
      value,
      hideDefault,
      ...options
    } = this.props;
    const {
      changeKey,
      units,
      baseUnit
    } = this.state;
    return /*#__PURE__*/_jsxs(Flex, {
      variant: "rowS",
      children: [/*#__PURE__*/_jsx(NumericInput, {
        ...options,
        float: true,
        onChange: this.onChange,
        value: value?.value,
        onDoubleClick: stopProp,
        validator: this.validator,
        eventData: "setValue"
      }), /*#__PURE__*/_jsx(UnitSelector, {
        ...options,
        units: units,
        hideDefault: hideDefault,
        unitType: valueType,
        baseUnits: false,
        value: value?.unit || baseUnit,
        onChange: this.onChange,
        eventData: "setUnit"
      })]
    }, changeKey);
  }
}
function stopProp(e) {
  if (e.stopPropagation) {
    e.stopPropagation();
  }
}